import {
  Facebook,
  Instagram,
  MailOutline,
  Telegram,
} from "@mui/icons-material";
import manone from "./assets/manone.jpg";
import mantwo from "./assets/mantwo.jpg";
import manthree from "./assets/manthree.jpg";
import womanone from "./assets/womanone.jpg";
import womantwo from "./assets/womantwo.jpg";
import womanthree from "./assets/womanthree.jpg";
import womanfour from "./assets/womanfour.jpg";
import manfour from "./assets/manfour.jpg";
import purse from "./assets/purse.jpg";
import watch from "./assets/watch.jpg";

export const sliderItems = [
  {
    img: manone,
  },
  {
    img: purse,
  },

  {
    img: womanone,
  },
  {
    img: watch,
  },
  {
    img: mantwo,
  },
  {
    img: womantwo,
  },
  {
    img: manthree,
  },
  {
    img: womanthree,
  },
  {
    img: manfour,
  },
  {
    img: womanfour,
  },
];

export const categories = [
  {
    id: 1,
    img: "https://images.pexels.com/photos/5886041/pexels-photo-5886041.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "SHIRT STYLE!",
    category: "woman",
  },
  {
    id: 2,
    img: "https://images.pexels.com/photos/2983464/pexels-photo-2983464.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "LOUNGEWEAR LOVE",
    category: "man",
  },
  {
    id: 3,
    img: "https://images.pexels.com/photos/5480696/pexels-photo-5480696.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    title: "LIGHT JACKETS",
    category: "jeans",
  },
];

export const popularProducts = [
  {
    id: 2,
    img: "https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png",
    category: "Shirt",
  },

  {
    id: 5,
    img: "https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
    category: "Bag",
  },

  {
    id: 8,
    img: "https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
    category: "Gown",
  },
];

export const awards = [
  {
    icon: <Facebook />,
    num: "32 M	",
    name: "Ecom Burmin Award",
  },
  {
    icon: <Instagram />,
    num: "43 M",
    name: "PH P1 Award",
  },
  {
    icon: <Telegram />,

    num: "51 M",
    name: "Nigerian ITC Award",
  },
  {
    icon: <MailOutline />,
    num: "42 M",
    name: "Best Response Award",
  },
];
